// src/shared/hooks/useDebouncedValue.js
import { useEffect, useState } from 'react';

/**
 * Returns `value` only after it has been stable for `delayMs` milliseconds.
 *
 * Used to debounce high-frequency inputs (e.g. the dashboard search box) so
 * each keystroke does not immediately trigger a full data reload. The first
 * render returns the initial value synchronously, so consumers never observe
 * a stale/empty state on mount.
 *
 * React 17 compatible (setTimeout only, no useSyncExternalStore).
 */
export default function useDebouncedValue(value, delayMs = 300) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setDebounced(value);
    }, delayMs);
    return () => window.clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}